// extracted by mini-css-extract-plugin
module.exports = {"pricing-page":"styles_pricing-page__3SSx-"};